import React, { FC, ReactElement, useEffect, useState } from "react";
import Modal from 'react-modal';
import { DATE_FILTER_ELEMENT_SYSNAME, TIME_FILTER_ELEMENT_SYSNAME, INACTIVE_FOR_FILTER_ELEMENT_SYSNAME } from "../../constants/element-type";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import { useFilter } from "../../contexts/table/FilterContext";
import WizardSideBarStep from "../../models/WizardSideBarStep";
import Wizard from "../wizard/wizard";
import DateFilterWizard from "./date-filter/date-filter-wizard";
import { TypeStep } from "./type-step";
import TimeFilterWizard from "./time-filter/time-filter-wizard";
import EntityFilterWizard from "./entity-filter/entity-filter-wizard";
import { useTable } from "../../contexts/table/TableContext";
import InactiveForFilterWizard from "./inactive-for-filter/inactive-for-filter-wizard";

interface FilterModalProps {
    isOpen: boolean;
    onClose: () => void;
    filterModalTrigger: string;
}

const FilterModal: FC<FilterModalProps> = ({ isOpen, onClose, filterModalTrigger }) => {
    const { translate } = useLocale();
    const [type, setType] = useState<string>("");
    const [typeDescription, setTypeDescription] = useState<string>(translate.byKey(TranslationKeys.pending));
    const filterContext = useFilter();
    const tableContext = useTable();
    const Entities = ["floor", "controller", "building", "zone", "reader", "company", "department", "profileName", "site", "displayName"];

    useEffect(() => {
        const filter = filterContext.filters.find(filter => filter.key === filterModalTrigger);
        if (isOpen && filter) {
            if (filterModalTrigger === "dateOnly") {
                setType(DATE_FILTER_ELEMENT_SYSNAME);
                setTypeDescription(translate.byKey(TranslationKeys.dateFilter));
            } else if (filterModalTrigger === "inactiveFor") {
                setType(INACTIVE_FOR_FILTER_ELEMENT_SYSNAME);
                setTypeDescription(translate.byKey(TranslationKeys.inactiveFor));
            } else {
                setType(TIME_FILTER_ELEMENT_SYSNAME);
                setTypeDescription(translate.byKey(TranslationKeys.timeFilter));
            }
        }
    }, [isOpen]);

    const handleClose = () => {
        setType('');
        onClose();
    }

    const onNext = (event: any) => {
        setType(event.elementSysname);
        setTypeDescription(event.name);
    }

    const content: ReactElement[] = [
        <TypeStep
            key={"wizard-1"}
            menuId={tableContext.menuId}
            onNext={onNext} />
    ]

    const steps: WizardSideBarStep[] = [
        {
            title: translate.byKey(TranslationKeys.filterType),
            description: typeDescription,
            substeps: []
        }
    ];

    const getWizard = () => {
        if (type === DATE_FILTER_ELEMENT_SYSNAME) {
            return <DateFilterWizard
                onClose={onClose}
                defaultContent={content}
                defaultSteps={steps}
                onReset={resetKeyField}
                filterModalTrigger={filterModalTrigger} />
        }
        else if (type === TIME_FILTER_ELEMENT_SYSNAME) {
            return <TimeFilterWizard
                onClose={onClose}
                defaultContent={content}
                defaultSteps={steps}
                filterModalTrigger={filterModalTrigger} />
        }
        else if (type === INACTIVE_FOR_FILTER_ELEMENT_SYSNAME) {
            return <InactiveForFilterWizard
                onClose={onClose}
                defaultContent={content}
                defaultSteps={steps}
                onReset={resetKeyField}
                filterModalTrigger={filterModalTrigger} />
        }
        else if (Entities.includes(type)) {
            return <EntityFilterWizard
                onClose={onClose}
                defaultContent={content}
                defaultSteps={steps}
                filterModalTrigger={filterModalTrigger}
                type={type} 
                onReset={resetKeyField}/>
        }

        return <Wizard name={translate.byKey(TranslationKeys.dataFilters)}
            step={0}
            onClose={handleClose}
            sidebarSteps={steps}>
            {content}
        </Wizard>
    }

    const resetKeyField = () => {
        setType("");
        setTypeDescription(translate.byKey(TranslationKeys.pending));
    }

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        {getWizard()}
    </Modal>
}

export default FilterModal;
